import { Area, AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const WeeklyEngagementChart = () => {
  // Hardcoded data for the chart
  const data = [
    { name: '5k', sales: 20, profit: 30 },
    { name: '10k', sales: 25, profit: 65 },
    { name: '15k', sales: 30, profit: 35 },
    { name: '20k', sales: 40, profit: 45 },
    { name: '25k', sales: 55, profit: 40 },
    { name: '30k', sales: 45, profit: 50 },
    { name: '35k', sales: 85, profit: 55 },
    { name: '40k', sales: 65, profit: 45 },
    { name: '45k', sales: 45, profit: 40 },
    { name: '50k', sales: 65, profit: 35 },
    { name: '55k', sales: 45, profit: 55 },
    { name: '60k', sales: 35, profit: 85 },
  ];

  return (
    <div className="h-[400px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#B4E50D" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#B4E50D" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorProfit" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#B4E50D" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#B4E50D" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#3A3A3A" />
          <XAxis dataKey="name" tick={{ fill: '#B0B0B0' }} />
          <YAxis tick={{ fill: '#B0B0B0' }} />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#2A2A2A', 
              border: '1px solid #3A3A3A',
              borderRadius: '8px',
              color: '#FFFFFF'
            }}
          />
          <Legend wrapperStyle={{ color: '#FFFFFF' }} />
          <Area
            type="monotone"
            dataKey="sales"
            stroke="#B4E50D"
            fillOpacity={1}
            fill="url(#colorSales)"
            name="Sales"
          />
          <Area
            type="monotone"
            dataKey="profit"
            stroke="#B4E50D"
            fillOpacity={1}
            fill="url(#colorProfit)"
            name="Profit"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklyEngagementChart;